/**
 * Shared marketing chrome strings (the `mk` namespace).
 *
 * Used by the reusable marketing-kit components and the public use-case /
 * integration / pricing pages for bits of UI that repeat across pages:
 * capability-status chips, the "related links" heading, and the handful of
 * CTA labels that recur. Page-specific copy lives in each page's own
 * fragment (e.g. `uc-ticket-questions.ts`, `intg-slack.ts`).
 */

export const mkEn = {
  cap: {
    supported: "Supported",
    conditional: "Configuration-dependent",
    unavailable: "Not available — by design",
  },
  relatedTitle: "Keep exploring",
  cta: {
    bookDemo: "Book a demo",
    talkToUs: "Talk to us",
    contactUs: "Contact us",
    viewPricing: "View pricing",
    startTrial: "Get started free",
  },
  footer: {
    tagline:
      "The governance layer for AI-assisted support, engineering remediation and deployment. Proposals stay inside roles, approvals, audit trails and per-capability health.",
    useCases: "Use cases",
    integrations: "Integrations",
    resources: "Resources",
    rights: "All rights reserved.",
    legal: "FixControl is a trade name of {legal} · KvK {kvk} · BTW {vat}",
    legalPreRegistration: "FixControl is a trade name of {legal}",
    links: {
      supportDemo: "Support & email automation",
      engineeringDemo: "Bug & code automation",
      ticketQuestions: "Slack & Jira ticket questions",
      approvedReplies: "Approved Freshdesk & Jira replies",
      remediation: "Support → engineering remediation",
      approvalLedger: "AI approval ledger",
      deployment: "Deployment governance",
      hrGoverned: "Governed HR answers",
      product: "Product",
      changeValidation: "Change validation",
      businessValue: "Business value",
      pricing: "Pricing",
      docs: "Documentation",
      security: "Security & governance",
      about: "About",
      bookDemo: "Book a demo",
      contact: "Contact",
    },
  },
};

export const mkNl = {
  cap: {
    supported: "Ondersteund",
    conditional: "Afhankelijk van configuratie",
    unavailable: "Niet beschikbaar — met opzet",
  },
  relatedTitle: "Verder verkennen",
  cta: {
    bookDemo: "Boek een demo",
    talkToUs: "Neem contact op",
    contactUs: "Neem contact op",
    viewPricing: "Bekijk prijzen",
    startTrial: "Begin gratis",
  },
  footer: {
    tagline:
      "De governance-laag voor AI-ondersteunde support, engineering-remediatie en deployment — voorstellen blijven binnen rollen, goedkeuringen, audittrails en capability-health.",
    useCases: "Use-cases",
    integrations: "Integraties",
    resources: "Bronnen",
    rights: "Alle rechten voorbehouden.",
    legal: "FixControl is een handelsnaam van {legal} · KvK {kvk} · BTW {vat}",
    legalPreRegistration: "FixControl is een handelsnaam van {legal}",
    links: {
      supportDemo: "Support- & e-mailautomatisering",
      engineeringDemo: "Bug- & codeautomatisering",
      ticketQuestions: "Slack- & Jira-ticketvragen",
      approvedReplies: "Goedgekeurde Freshdesk- & Jira-antwoorden",
      remediation: "Support → engineering-remediatie",
      approvalLedger: "AI-goedkeuringsgrootboek",
      deployment: "Deployment-governance",
      hrGoverned: "Gegoverneerde HR-antwoorden",
      product: "Product",
      changeValidation: "Change-validatie",
      businessValue: "Businesswaarde",
      pricing: "Prijzen",
      docs: "Documentatie",
      security: "Security & governance",
      about: "Over ons",
      bookDemo: "Boek een demo",
      contact: "Contact",
    },
  },
};
